import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateBrand() {
    yield takeEvery(actions.CREATE_OR_UPDATE_BRAND_REQUESTED, function* (action) {
        try {
            const brand = yield call(actions.createOrUpdateBrand, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_BRAND_SUCCEEDED, brand });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_BRAND_FAILED, error: error.response.data.message });
        }
    });
}
export default function* rootSaga() {
    yield all([
        fork(createOrUpdateBrand)
    ]);
}
